import { assertAA } from './contrast.js';
import { tokens } from './tokens.js';
/** AA pary, ktere kazde tema MUSI splnit (fail-fast pri kompilaci). */
function aaPairs(t) {
    return [
        [t.text, t.card, `${t.name}: text/card`],
        [t.text, t.canvas, `${t.name}: text/canvas`],
        [t.textMuted, t.card, `${t.name}: textMuted/card`],
        [t.textMuted, t.canvas, `${t.name}: textMuted/canvas`],
        [t.accentText, t.accent, `${t.name}: accentText/accent`],
        [t.accent, t.card, `${t.name}: accent/card (odkazy)`],
        [t.success, t.successBg, `${t.name}: success/successBg`],
        [t.warning, t.warningBg, `${t.name}: warning/warningBg`],
        [t.danger, t.dangerBg, `${t.name}: danger/dangerBg`],
        // UI komponenty (3:1): akcent proti platnu (ohraniceni, fokus ring)
        [t.accent, t.canvas, `${t.name}: accent/canvas (UI)`, 3],
    ];
}
/**
 * Kompilace tematu do CSS custom properties pod [data-theme="name"].
 * Hazi chybu (fail-fast) pri poruseni AA — tema se nesmi dostat do buildu.
 */
export function compileTheme(t) {
    assertAA(aaPairs(t));
    const vars = [
        ['--rh-accent', t.accent],
        ['--rh-accent-text', t.accentText],
        ['--rh-accent-soft', t.accentSoft],
        ['--rh-canvas', t.canvas],
        ['--rh-card', t.card],
        ['--rh-border', t.border],
        ['--rh-text', t.text],
        ['--rh-text-muted', t.textMuted],
        ['--rh-success', t.success],
        ['--rh-success-bg', t.successBg],
        ['--rh-warning', t.warning],
        ['--rh-warning-bg', t.warningBg],
        ['--rh-danger', t.danger],
        ['--rh-danger-bg', t.dangerBg],
        ['--rh-chart-1', t.chart[0]],
        ['--rh-chart-2', t.chart[1]],
        ['--rh-chart-3', t.chart[2]],
        ['--rh-chart-4', t.chart[3]],
        ['--rh-chart-5', t.chart[4]],
        ['--rh-radius-control', tokens.radius.control],
        ['--rh-radius-card', tokens.radius.card],
        ['--rh-radius-shell', tokens.radius.shell],
        ['--rh-font-sans', tokens.typography.fontSans],
    ];
    const body = vars.map(([k, v]) => `  ${k}: ${v};`).join('\n');
    return `[data-theme="${t.name}"] {\n${body}\n}`;
}
//# sourceMappingURL=compile.js.map